var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 29 29",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0066 12.757V1.63962C13.0066 0.871839 13.6284 0.25 14.3962 0.25C15.164 0.25 15.7858 0.871839 15.7858 1.63962V12.757H26.9028C27.6706 12.757 28.2924 13.3788 28.2924 14.1466C28.2924 14.9144 27.6706 15.5362 26.9028 15.5362H15.7858V26.6528C15.7858 27.4206 15.164 28.0424 14.3962 28.0424C13.6284 28.0424 13.0066 27.4206 13.0066 26.6528V15.5362H1.88962C1.12184 15.5362 0.5 14.9144 0.5 14.1466C0.5 13.3788 1.12184 12.757 1.88962 12.757H13.0066Z",
    fill: "black"
  })));
};
export default __webpack_public_path__ + "static/media/union.0487ca41.svg";
export { SvgComponent as ReactComponent };